import React from 'react';

const initialValues = {
  actionItems: [],
  unreadCount: 0,
  isReady: false,
  markAsRead: () => {},
  resolveItem: () => {},
  internalUsers: [],
  loadInternalUsers: () => {},
};

const ActionItemsContext = React.createContext(initialValues);

export default ActionItemsContext;
export { initialValues };
